import React from "react";

import classNames from "classnames";
import { Button, CloseButton, Modal } from "react-bootstrap";

import { useBookingModalContext } from "../contexts/BookingModal";
import { dateFormat, timeFormat } from "../lib/dateFormats";
import { useOpenGamesContext } from "../contexts/OpenGames";
import Loading from "../../../components/Loading";
import { useButtonHandlers } from "../hooks/useButtonHandlers";

const BookingModal = () => {
    const {
        showBookingModal,
        setShowBookingModal,
        bookingModalContent,
        bookingStatus,
        bookingStatusMessage,
        setBookingStatusMessage,
        setBookingStatus,
        setBookingModalContent,
    } = useBookingModalContext();

    const { site } = useOpenGamesContext();
    const { handleBookingConfirmClick } = useButtonHandlers();
    const { game, location } = bookingModalContent ?? {};

    const handleClose = () => {
        setBookingStatus(undefined);
        setShowBookingModal(false);
        setBookingStatusMessage("");
        setBookingModalContent(undefined);
    };

    return (
        <Modal
            className={classNames("bookingModal")}
            centered
            show={showBookingModal}
            onHide={handleClose}
        >
            <Modal.Header>
                <h4>Do you wish to schedule this game?</h4>
                <CloseButton onClick={handleClose} />
            </Modal.Header>
            <Modal.Body>
                {game && (
                    <dl className={classNames("inline")}>
                        <dt>Date:</dt>
                        <dd>{dateFormat.format(new Date(game.date))}</dd>
                        <dt>Time:</dt>
                        <dd>{timeFormat.format(new Date(game.date))}</dd>
                        <dt>Age Level:</dt>
                        <dd>{game.ageLevel.ageLevel || "TBD"}</dd>
                        <dt>{site === 1 ? "League:" : "Tournament:"}</dt>
                        <dd>{game.leagueName}</dd>
                        {site === 1 && (
                            <>
                                <dt>Teams:</dt>
                                <dd>
                                    {`${game.visitor.name || "TBD"} @ ${game.home.name || "TBD"}`}
                                </dd>
                            </>
                        )}
                        <dt>Location:</dt>
                        <dd>{game.fieldName}</dd>
                        {game.diamond && (
                            <>
                                <dt>Diamond:</dt>
                                <dd>{game.diamond}</dd>
                            </>
                        )}
                        {game.note && (
                            <>
                                <dt>Game/Field Note:</dt>
                                <dd>{game.note}</dd>
                            </>
                        )}
                    </dl>
                )}
                {bookingStatus === "pending" && <Loading />}
                <h4
                    className={classNames({
                        statusMessage: true,
                        bookingStatus: true,
                        "text-primary": bookingStatus === "success",
                        "text-danger": bookingStatus === "failed",
                        "d-none": !bookingStatus || bookingStatus === "pending",
                    })}
                >
                    {bookingStatusMessage}
                </h4>
            </Modal.Body>
            <Modal.Footer>
                <Button
                    variant="danger"
                    onClick={handleClose}
                    disabled={bookingStatus === "pending"}
                >
                    {bookingStatus === "success" || bookingStatus === "failed"
                        ? "Close"
                        : "No"}
                </Button>
                {bookingStatus !== "success" && bookingStatus !== "failed" && (
                    <Button
                        variant="primary"
                        disabled={bookingStatus === "pending"}
                        onClick={() =>
                            game &&
                            location &&
                            handleBookingConfirmClick(game, location)
                        }
                    >
                        Yes
                    </Button>
                )}
            </Modal.Footer>
        </Modal>
    );
};

export default BookingModal;
